// extracted by mini-css-extract-plugin
export default {"dialog":"FullScreenDialog_dialog__YCLY2","appBar":"FullScreenDialog_appBar__DgTXc","title":"FullScreenDialog_title__MeI6l"};